<template>
  <v-flex
    xs12
    md10
    offset-md1
    align-self-center
    justify-center
  >
    <v-row>
        <v-col
          cols="8"
        >
          <AutoComplete
          :value="searchEditor"
          v-model="searchEditor"
          key-value="id"
          key-name="name"
          enable-chips
          enable-clearable
          enable-autofocus
          :items="editors"
          :label="$t('fields.editor')"
          @search="searchEditors"
          @input="fetchEditorsIfExist"
          @clear="deleteSelectedEditors"
          :delay="900"
          :errors="errors"
        >
        </AutoComplete>
        </v-col>
    </v-row>
    <v-card flat light>
      <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="totalItems"
        :no-data-text="$t('NO_DATA')"
        :no-results-text="$t('NO_DATA')"
        hide-default-footer
        :options.sync="pagination"
        :loading="loading"
        class="elevation-1"
      >
      </v-data-table>
      <Paginator
        :total-items="totalItems"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        @change="fetchReport"
      />
    </v-card>
  </v-flex>
</template>
<script>

import { adoptionsService } from '../../../utils/services/adoptions.service';
import { editorsService } from '../../../utils/services/editors.service';
import AutoComplete from '../../../components/shared/Inputs/AutoComplete.vue';
import Paginator from '../../../components/shared/Paginator';

export default {
  name: 'AdoptionReportEditorPropagandist',
  components: { AutoComplete, Paginator },
  data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        searchEditor: null,
        editor: {},
        editors: [],
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['editor'],
        },
        headers: [
          { text: this.$t('fields.editor'), value: 'editor' },
          { text: this.$t('fields.propagandist'), value: 'propagandist' },
          { text: this.$t('fields.section'), value: 'counter_section' },
          { text: this.$t('fields.is_new'), value: 'counter_new' },
          { text: this.$t('fields.capociclo'), value: 'counter_capociclo' },
        ],
        filters: {
          editorId: null,
          searchEditor: null,
        },
      };
    },

    computed: {
      requestFilters() {
        const filters = {
          editorId: this.filters.editorId,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },

    methods: {

      deleteSelectedEditors() {
        this.editor = {};
        this.filters.editorId = null;
      },

      async searchEditors(val) {
        this.filters.searchEditor = val;
        await this.fetchEditors();
      },

      async fetchEditorsIfExist(id) {
        if (id > 0) {
          this.filters.editorId = id;
          await this.fetchEditor(id);
        } else {
          this.filters.editorId = 0;
        }
      },

      async fetchEditors() {
        this.loading = true;
        return editorsService.index({
          filters: {
            search: this.filters.searchEditor,
          },
        })
        .then(response => {
            this.editors = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchEditor(id) {
        this.loading = true;
        return editorsService.get(id)
        .then(response => {
            this.editor = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchReport(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return adoptionsService.reportPropagandistEditor({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        },
          )
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
              this.handleError(error, this.errors);
          }).finally(() => {
            this.loading = false;
          });
      },
    },
    async created() {
      this.fetchReport(1);
    },
    watch: {
      'filters.editorId': {
        handler() {
          this.fetchReport(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchReport(1);
          }
        },
      },
    },
};
</script>
